module.exports = __webpack_public_path__ + "img/gr.b0f05ef8.png";